import type { CommentsFormProps } from "./comment-form.type";

import { Button, Checkbox, Form, Input, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { CurrentUserAvatar } from "@/modules/current-user-avatar";

import { useCommentFormLayout } from "./comment-form.hook";

import "./comment-form.style.less";

const { Item } = Form;
const { TextArea } = Input;
const { Title } = Typography;

// See formProps API -> https://ant.design/components/form#form
const CommentForm = ({
  form,
  isLoading,
  showTitle,
  disabled,
  ...formProps
}: CommentsFormProps) => {
  const { t } = useTranslation();
  const { formLayout, fieldRows, onFieldFocus, onFieldKeyDown, onCancelClick } =
    useCommentFormLayout(form);

  const fieldRules = [
    { required: true, message: t("form:validateMessages.required") },
    { max: 2000, message: t("form:validateMessages.string.max") },
  ];

  return (
    <div className="comment-form">
      {showTitle && (
        <Title level={3} className="comment-form-title">
          {t("comment:plural")}
        </Title>
      )}
      <div className="comment-form-content">
        <CurrentUserAvatar withTooltip />
        <Form
          layout={formLayout}
          {...formProps}
          form={form}
          disabled={disabled || isLoading}
        >
          <Item name="comment" rules={fieldRules} className="comment-field">
            <TextArea
              rows={fieldRows}
              onFocus={onFieldFocus}
              onKeyDown={onFieldKeyDown}
              placeholder={t("comment:form.field.placeholder")}
            />
          </Item>
          <Item name="focus" valuePropName="checked" hidden>
            <Checkbox />
          </Item>
          <Item className="form-actions">
            <Button type="primary" htmlType="submit" loading={isLoading}>
              {t("comment:form.actions.submit")}
            </Button>
            <Button onClick={onCancelClick} htmlType="reset">
              {t("comment:form.actions.cancel")}
            </Button>
          </Item>
        </Form>
      </div>
    </div>
  );
};

export default CommentForm;
